import styled from "styled-components";
import React from "react";

const SelectContainer = styled.div`
  margin-bottom: 10px;
  margin-left: 5px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    margin-bottom: 15px;
  }
`;

const Select = styled.div`
  font-family: Lato;
  text-transform: uppercase;
  font-style: normal;
  font-weight: bold;
  margin-bottom: 10px;

  background: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme]
      .quicklinkSelectBackgroundColor};
  color: #fff;
  border-radius: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 265px;
  height: 40px;

  font-size: 14px;
  line-height: 17px;

  span {
    margin-left: 32.72px;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      margin-left: 24px;
      font-size: 14px;
      line-height: 17px;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      margin-left: 23.2px;
      font-size: 20px;
      line-height: 24px;
    }
  }

  div {
    margin-right: 19px;
    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      margin-right: 14px;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      margin-right: 14.76px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 232px;
    height: 40px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 196px;
    height: 40px;
  }

  &:hover {
    color: #fff;
    background: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].main};
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
  }

  &:focus {
    background: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].focusColor};
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
    box-shadow: 0 0 2px 2px
      ${(props) => props.theme.themeColors[props.theme.activeTheme].focusColor};
  }
`;

const DetailsContainer = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  background: #fbfbfb;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    background: #fbfbfb;
    border-top: 1px solid #eee;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 100%;
    height: 95px;
    border-top: none;
    justify-content: flex-start;
    flex-direction: column-reverse;
    padding: 0;
  }
`;

const DisclaimerAndInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 64px;
  justify-content: center;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    flex-direction: row;
  }

  @media screen and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    align-items: flex-end;
    justify-content: space-around;
  }

  .ApartmentInfoWrapper {
    width: 100%;
  }
`;

const Name = styled.div`
  background: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].nameBackgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].nameTextColor};
  font-family: Lato;
  text-transform: uppercase;
  border: 2px solid
    ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].nameBorderColor};
  box-sizing: border-box;
  font-style: normal;
  border-radius: 10px;
  font-weight: 900;
  margin-bottom: 9px;
  padding: 10px;

  font-size: 12px;
  line-height: 14px;

  width: ${(prop) => (prop.hasDesc ? "270px" : "100%")};
  height: 49.96px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: ${(prop) => (prop.hasDesc ? "216px" : "100%")};
    height: 33px;
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 15px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    font-size: 18px;
    line-height: 22px;
    width: ${(prop) => (prop.hasDesc ? "377px" : "100%")};
    height: 59px;
  }
`;
const Price = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  align-items: flex-end;
  font-style: normal;
  font-weight: normal;
  font-family: Lato;
  background: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].priceBackgroundColor};
  border: 2px solid
    ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].priceBorderColor};

  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 6px;
  width: 270px;
  height: 50px;
  padding-right: 40px;
  padding-bottom: 7px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 175px;
    height: 45px;
    padding-right: 11px;
    padding-bottom: 7px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 377px;
    height: 76px;
    padding-right: 28px;
    padding-bottom: 14px;
  }

  ${({ hasPrice }) =>
    !hasPrice &&
    `
    padding: 0 10px !important;
    justify-content: center;
    align-items: center;
  `};

  span:nth-child(1) {
    font-size: ${(prop) => (prop.hasLargePrice ? "16px" : "15px")};
    line-height: 22px;
    color: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].priceTextColor};
    ${({ hasPrice }) => hasPrice && `margin-right: 20px;`}
  }

  span:nth-child(2) {
    font-family: "Rockwell Std";
    text-transform: uppercase;
    box-sizing: border-box;
    border-bottom: 3px solid rgba(66, 172, 205, 0.9);
    font-size: ${(prop) => (prop.hasLargePrice ? "24px" : "28px")};
    line-height: 24px;
    font-weight: 900;
    color: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].priceTextColor};
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    span:nth-child(1) {
      font-size: 12px;
      line-height: 1;
      ${({ hasPrice }) => hasPrice && `margin-right: 12px;`}
    }

    span:nth-child(2) {
      border-bottom: 3px solid rgba(66, 172, 205, 0.9);
      font-size: ${(prop) => (prop.hasLargePrice ? "20px" : "24px")};
      line-height: 20px;
      font-weight: 900;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    span:nth-child(1) {
      font-size: 23px;
      ${({ hasPrice }) => hasPrice && `margin-right: 20px;`}
    }

    span:nth-child(2) {
      text-transform: uppercase;
      border-bottom: 3px solid rgba(66, 172, 205, 0.9);
      font-size: 36px;
      line-height: 31px;
      font-weight: 900;
    }
  }

  color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].quicklinksBorderColor};
`;

const Disclaimer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #979797;
  padding-bottom: 3px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;

  font-size: 9px;
  line-height: 11px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    font-size: 7px;
    line-height: 8px;
    justify-content: flex-start;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    font-size: 10px;
    line-height: 12px;
    justify-content: flex-end;
  }
`;

const BedroomDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #f4f4f4;
  background: #fff;
  font-family: "DM Sans";
  font-size: 11px;
  color: #0f0538;
  margin-bottom: 8px;
  margin-top: -5px;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    margin-top: 10px;
    justify-content: start;
    margin-bottom: 5px;
    border: none;
    background-color: transparent;
  }
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 15px;
  /* margin-bottom: 8px; */
  align-items: start;
  justify-content: center;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    margin-right: 0px;
    /* margin-bottom: 12px; */
  }

  .info-image {
    display: flex;
    /* height: 100%; */
  }

  .info-number {
    display: flex;
    align-items: end;
    padding-bottom: 6px;
    font-size: 21px;
    margin-right: 3px;
    color: var(--Primary-Dark-Blue);
    border-bottom: 2px solid #39abcf;
    font-weight: 600;

  }

  .info-description {
    color: #999;
    font-family: "DM Sans";
    font-size: 10px;
    margin-top :3px;
  }
`;

const ApartmentInfo = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 64px;

  > div {
    display: flex;
    gap: 25px;
  }

  > div:last-of-type {
    margin-left: auto;
   }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    > div:last-of-type {
      display: flex;
      justify-content: end;
      gap: 20px;
      margin-left: 0; 

    }
    > div:first-of-type {
      margin-right: 25px;
    }
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    justify-content: start;
  }
`;

const ApartmentInfoEmptyPrice = styled.div`
  display: flex;
  justify-content: space-around !important;

  @media only screen and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) {
    position: relative;
    left: 31%;
    margin-top: -15px !important;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    justify-content: space-between;
  }
`;

const DescImg = styled.img`
  image-rendering: auto;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
  image-rendering: -webkit-optimize-contrast;
  height: 21px;
  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    margin-bottom: 0px;
  }
`;

const PriceDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-family: "Rockwell Std";
  color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].priceDescriptionTextColor};

  div {
    display: flex;
    justify-content: flex-end;
    border-bottom: 2px solid rgba(66, 172, 205, 0.9);
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 20px;
    margin-top: 4px;
    margin-bottom: 3px;

    @media screen and (min-width: ${(prop) =>
        prop.theme.screenSizes.breakSmall}) {
      line-height: 19px;
      margin-top: 0px;
    }

    @media screen and (min-width: ${(prop) =>
        prop.theme.screenSizes.breakLaptop}) {
      border-bottom: 3px solid rgba(66, 172, 205, 0.9);
      width: 73px;
      font-size: 34px;
      line-height: 28px;
    }
  }

  span:nth-child(2) {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 12px;
    text-align: right;
    color: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].descriptionTextColor};

    @media screen and (min-width: ${(prop) =>
        prop.theme.screenSizes.breakSmall}) {
      font-size: 9px;
      line-height: 11px;
    }

    @media screen and (min-width: ${(prop) =>
        prop.theme.screenSizes.breakLaptop}) {
      font-size: 14px;
      line-height: 17px;
    }
  }
`;

const NameAndPrice = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) {
    justify-content: space-between;

    flex-direction: row-reverse;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    flex-direction: column;
  }
`;

const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 9%;
  flex-direction: column;

  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakSmall}) {
    flex-direction: row;
    .QuickLinksContainer .QuicklinkButton > div {
      width: 200px !important;
      height: 40px !important;
      min-height: 40px;
    }

    .BackQuickLinkWrapper {
      height: 40px;
    }

    .quickLinks {
      width: 200px !important;
      height: 40px; !important;
    }
  }
`;

const unitIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M10.6774 19.5833H20V4H3V19.5833H5.29213"
      stroke="#666666"
      strokeWidth="1.73676"
      strokeLinecap="round"
    />
    <path
      d="M3 11.1187L5.9 11.1187H11.5V7.3999V14.4832"
      stroke="#666666"
      strokeWidth="1.73676"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const unitIconLight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M9.17742 16.3024H18.5V1H1.5V16.3024H3.79213"
      stroke="#42ACCD"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M1.5 7.99154L4.4 7.99154H10V4.33984V11.2955"
      stroke="#42ACCD"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const unitIconGreen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
  <path d="M9.17742 16.7917H18.5V1.20833H1.5V16.7917H3.79213" stroke="#4B8D71" stroke-width="1.73676" stroke-linecap="round"/>
  <path d="M1.50049 8.32707L4.40049 8.32707H10.0005V4.60832V11.6917" stroke="#4B8D71" stroke-width="1.73676" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)

const virtualIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M8.63287 19.3261C8.70723 19.3721 8.70232 19.4821 8.62407 19.5236L5.64887 21.1033C5.57101 21.1446 5.47884 21.0872 5.48274 20.9997L5.63103 17.6746C5.63493 17.5871 5.73198 17.5351 5.80596 17.5808L8.63287 19.3261Z"
      fill="#666666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.43986 7.60889C2.62565 8.72653 0 11.0683 0 13.7763C0 16.4842 2.62565 18.826 6.43986 19.9437V18.5113C5.55474 18.2242 4.75704 17.8663 4.06994 17.4561C2.20666 16.3436 1.36876 14.9992 1.36876 13.7763C1.36876 12.5533 2.20666 11.2089 4.06994 10.0965C4.75704 9.68623 5.55474 9.32839 6.43986 9.04122V7.60889ZM17.4799 18.175C18.0046 17.9601 18.49 17.7188 18.9301 17.4561C20.7933 16.3436 21.6312 14.9992 21.6312 13.7763C21.6312 12.5533 20.7933 11.2089 18.9301 10.0965C18.49 9.83372 18.0046 9.59247 17.4799 9.37752V7.9103C20.7901 9.11576 23 11.2919 23 13.7763C23 16.2606 20.7901 18.4368 17.4799 19.6422V18.175Z"
      fill="#666666"
    />
    <path
      d="M14.5019 19.3261C14.4275 19.3721 14.4324 19.4821 14.5107 19.5236L17.4859 21.1033C17.5638 21.1446 17.6559 21.0872 17.652 20.9997L17.5037 17.6746C17.4998 17.5871 17.4028 17.5351 17.3288 17.5808L14.5019 19.3261Z"
      fill="#666666"
    />
    <mask
      id="mask0_2426_23780"
      maskUnits="userSpaceOnUse"
      x="3"
      y="1"
      width="18"
      height="14"
    >
      <rect x="3.1543" y="1" width="17.3056" height="13.8445" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2426_23780)">
      <path
        d="M25.9559 16.1447C25.7171 14.8868 25.2738 13.629 24.5918 12.3381C24.4555 12.1063 24.3189 11.8417 24.1483 11.5436C24.1143 11.4773 24.046 11.4443 23.9437 11.4113C23.8754 11.4113 23.7731 11.4113 23.7391 11.4776C22.6819 12.4374 21.454 13.3975 20.1239 14.3243C19.5441 14.7215 18.93 15.1188 18.2823 15.516C18.18 15.5823 18.1459 15.6816 18.18 15.7808C18.214 15.8801 18.3163 15.9794 18.4188 15.9794C18.7257 16.0124 19.0326 16.0457 19.3055 16.0457C19.6124 16.0787 19.9193 16.112 20.2265 16.112C20.0559 16.1782 19.8853 16.2443 19.715 16.3105C19.2375 16.4761 18.726 16.6416 18.1802 16.807C16.0997 17.3697 13.61 17.6676 10.9838 17.6676C7.67545 17.6676 4.57177 17.2041 2.25253 16.3436C0.683509 15.7479 -0.407775 15.0196 -0.782946 14.3244C-0.851226 14.2251 -0.885248 14.1258 -0.919269 14.0265C-0.95329 13.9272 -0.953289 13.8279 -0.953289 13.7287C-0.953289 12.8348 0.240558 11.8417 2.25278 11.1137C2.52566 11.0144 2.79854 10.9151 3.10544 10.8159C3.10544 12.3387 4.40155 13.5633 5.93627 13.5633H16.9527C18.5217 13.5633 19.7835 12.3054 19.7835 10.8159L19.7828 5.02256C19.7828 3.49976 18.4867 2.27511 16.9519 2.27511H14.9397C14.5645 1.18275 13.5073 0.388184 12.2454 0.388184H10.6424C9.38056 0.388184 8.32332 1.18269 7.94815 2.27511H5.93593C4.36691 2.27511 3.10509 3.53304 3.10509 5.02256V9.19334C2.74236 9.29689 2.39372 9.40727 2.06018 9.52412C-0.80528 10.5279 -2.55664 12.0087 -2.55664 13.7282C-2.55664 14.0924 -2.48836 14.4565 -2.31778 14.8206C-1.15822 17.4025 4.16245 19.2562 10.9837 19.2562C16.3726 19.2562 20.8405 18.0975 23.0233 16.3432C23.91 16.3762 24.7969 16.4425 25.6836 16.4425H25.7519C25.8202 16.4425 25.8542 16.4094 25.8882 16.3432C25.9563 16.3104 25.9902 16.244 25.9559 16.1447ZM11.4607 3.5991C13.9163 3.5991 15.9286 5.55205 15.9286 7.93538C15.9286 10.3187 13.9163 12.2717 11.4607 12.2717C9.00501 12.2717 6.99279 10.3187 6.99279 7.93538C6.99279 5.55229 8.97096 3.5991 11.4607 3.5991Z"
        fill="#666666"
      />
      <path
        d="M14.2538 8.08429C14.2538 9.59252 12.9994 10.8153 11.452 10.8153C9.90481 10.8153 8.65039 9.59258 8.65039 8.08429C8.65039 6.57624 9.90481 5.35352 11.452 5.35352C12.9993 5.35352 14.2538 6.57624 14.2538 8.08429"
        fill="#666666"
      />
    </g>
  </svg>
);

const virtualIconLight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 19 15"
    fill="none"
  >
    <path
      d="M6.82864 13.2201C6.88744 13.2564 6.88356 13.3434 6.82167 13.3763L4.4688 14.6255C4.40722 14.6582 4.33433 14.6128 4.33742 14.5436L4.45469 11.914C4.45778 11.8449 4.53453 11.8037 4.59303 11.8398L6.82864 13.2201Z"
      fill="#42ACCD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.09375 3.9541C2.07686 4.83786 0 6.68999 0 8.83172C0 10.9735 2.07686 12.8256 5.09375 13.7093V12.5766C4.3934 12.3495 3.76225 12.0664 3.21863 11.7418C1.74509 10.862 1.08246 9.79889 1.08246 8.83172C1.08246 7.86455 1.74509 6.80139 3.21863 5.92162C3.76225 5.59705 4.3934 5.31395 5.09375 5.0868V3.9541ZM13.8245 12.31C14.2391 12.1401 14.6227 11.9495 14.9705 11.7418C16.444 10.862 17.1066 9.79889 17.1066 8.83172C17.1066 7.86455 16.444 6.80139 14.9705 5.92162C14.6227 5.71399 14.2391 5.52333 13.8245 5.35343V4.19307C16.4418 5.14645 18.1891 6.86726 18.1891 8.83172C18.1891 10.7962 16.4418 12.517 13.8245 13.4704V12.31Z"
      fill="#42ACCD"
    />
    <path
      d="M11.4682 13.2201C11.4094 13.2564 11.4133 13.3434 11.4752 13.3763L13.8281 14.6255C13.8897 14.6582 13.9625 14.6128 13.9595 14.5436L13.8422 11.914C13.8391 11.8449 13.7623 11.8037 13.7038 11.8398L11.4682 13.2201Z"
      fill="#42ACCD"
    />
    <mask
      id="mask0_3919_20754"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="14"
      height="11"
    >
      <rect x="2.37305" width="13.4441" height="10.2808" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3919_20754)">
      <path
        d="M20.5271 11.9773C20.3382 10.9825 19.9877 9.98786 19.4483 8.96696C19.3405 8.78363 19.2325 8.57437 19.0976 8.33864C19.0707 8.28624 19.0167 8.26012 18.9358 8.23401C18.8818 8.23401 18.8009 8.23401 18.774 8.28642C17.9379 9.04549 16.9668 9.80474 15.915 10.5377C15.4565 10.8518 14.9708 11.166 14.4585 11.4801C14.3776 11.5325 14.3507 11.6111 14.3776 11.6896C14.4046 11.7681 14.4855 11.8466 14.5665 11.8466C14.8093 11.8727 15.052 11.899 15.2678 11.899C15.5105 11.9251 15.7532 11.9514 15.9961 11.9514C15.8612 12.0038 15.7263 12.0561 15.5916 12.1085C15.214 12.2394 14.8095 12.3703 14.3779 12.5011C12.7325 12.9461 10.7636 13.1816 8.68669 13.1816C6.07036 13.1816 3.61587 12.8152 1.78175 12.1346C0.540923 11.6635 -0.322097 11.0876 -0.618793 10.5378C-0.672791 10.4592 -0.699697 10.3807 -0.726602 10.3022C-0.753507 10.2237 -0.753506 10.1452 -0.753506 10.0666C-0.753506 9.35979 0.190624 8.57441 1.78195 7.99868C1.99775 7.92016 2.21355 7.84164 2.45626 7.76312C2.45626 8.9674 3.48126 9.93589 4.69497 9.93589H13.4071C14.6479 9.93589 15.6458 8.94108 15.6458 7.76312L15.6452 3.18161C15.6452 1.97733 14.6202 1.00884 13.4065 1.00884H11.8152C11.5185 0.144966 10.6823 -0.483398 9.68444 -0.483398H8.41674C7.41881 -0.483398 6.58271 0.144919 6.28602 1.00884H4.69469C3.45387 1.00884 2.45598 2.00365 2.45598 3.18161V6.47998C2.16912 6.56187 1.89341 6.64917 1.62963 6.74157C-0.636456 7.53542 -2.02148 8.70643 -2.02148 10.0663C-2.02148 10.3543 -1.96749 10.6422 -1.83259 10.9302C-0.915573 12.9721 3.29217 14.438 8.68665 14.438C12.9483 14.438 16.4817 13.5217 18.2079 12.1343C18.9091 12.1604 19.6105 12.2128 20.3118 12.2128H20.3658C20.4198 12.2128 20.4467 12.1867 20.4736 12.1343C20.5274 12.1084 20.5542 12.0559 20.5271 11.9773ZM9.06383 2.05589C11.0058 2.05589 12.5972 3.60034 12.5972 5.48515C12.5972 7.36997 11.0058 8.91442 9.06383 8.91442C7.12181 8.91442 5.53049 7.36997 5.53049 5.48515C5.53049 3.60053 7.09489 2.05589 9.06383 2.05589Z"
        fill="#42ACCD"
      />
      <path
        d="M11.2731 5.60294C11.2731 6.7957 10.2811 7.76271 9.05737 7.76271C7.83383 7.76271 6.8418 6.79574 6.8418 5.60294C6.8418 4.41033 7.83383 3.44336 9.05737 3.44336C10.281 3.44336 11.2731 4.41033 11.2731 5.60294Z"
        fill="#42ACCD"
      />
    </g>
  </svg>
);

const virtualIconGreen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
<path d="M7.23391 13.7205C7.29271 13.7568 7.28884 13.8438 7.22695 13.8767L4.87407 15.126C4.81249 15.1587 4.73961 15.1132 4.74269 15.044L4.85996 12.4145C4.86305 12.3453 4.9398 12.3041 4.9983 12.3402L7.23391 13.7205Z" fill="#4B8D71"/>
<path fillRule="evenodd" clipRule="evenodd" d="M5.49902 4.45355C2.48225 5.33731 0.4054 7.18932 0.405273 9.33093C0.405273 11.4727 2.48214 13.3248 5.49902 14.2086V13.0759C4.79872 12.8487 4.16761 12.5656 3.62402 12.2411C2.15049 11.3613 1.4873 10.2981 1.4873 9.33093C1.48739 8.36382 2.15058 7.30049 3.62402 6.42078C4.1676 6.09626 4.79872 5.81316 5.49902 5.58598V4.45355ZM14.2298 12.8094C14.6445 12.6395 15.0282 12.4488 15.376 12.2411C16.8493 11.3613 17.5117 10.298 17.5117 9.33093C17.5116 8.36383 16.8494 7.30048 15.376 6.42078C15.0282 6.21311 14.6445 6.02241 14.2298 5.85248V4.69227C16.8472 5.64569 18.5946 7.36653 18.5947 9.33093L18.583 9.61023C18.4263 11.4579 16.7226 13.0617 14.2298 13.9696V12.8094Z" fill="#4B8D71"/>
<path d="M11.8735 13.7205C11.8147 13.7568 11.8186 13.8438 11.8805 13.8767L14.2334 15.126C14.2949 15.1587 14.3678 15.1132 14.3647 15.044L14.2475 12.4145C14.2444 12.3453 14.1676 12.3041 14.1091 12.3402L11.8735 13.7205Z" fill="#4B8D71"/>
<mask id="mask0_6680_1933" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="2" y="0" width="15" height="11">
<rect x="2.77832" y="0.499939" width="13.4441" height="10.2808" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_6680_1933)">
<path d="M20.9324 12.477C20.7435 11.4822 20.393 10.4875 19.8536 9.4666C19.7458 9.28326 19.6378 9.074 19.5029 8.83828C19.476 8.78587 19.422 8.75976 19.3411 8.73365C19.2871 8.73365 19.2062 8.73365 19.1793 8.78605C18.3432 9.54512 17.3721 10.3044 16.3202 11.0374C15.8617 11.3514 15.3761 11.6657 14.8638 11.9798C14.7829 12.0322 14.756 12.1107 14.7829 12.1892C14.8098 12.2677 14.8907 12.3462 14.9718 12.3462C15.2145 12.3724 15.4572 12.3987 15.6731 12.3987C15.9158 12.4248 16.1585 12.4511 16.4014 12.4511C16.2665 12.5035 16.1316 12.5557 15.9968 12.6081C15.6192 12.739 15.2147 12.87 14.7831 13.0007C13.1378 13.4457 11.1689 13.6813 9.09196 13.6813C6.47564 13.6813 4.02115 13.3148 2.18702 12.6343C0.946197 12.1631 0.0831764 11.5872 -0.21352 11.0374C-0.267518 10.9589 -0.294423 10.8804 -0.321328 10.8018C-0.348233 10.7233 -0.348232 10.6448 -0.348232 10.5663C-0.348232 9.85943 0.595898 9.07404 2.18722 8.49832C2.40302 8.4198 2.61882 8.34128 2.86153 8.26276C2.86153 9.46703 3.88653 10.4355 5.10024 10.4355H13.8123C15.0532 10.4355 16.051 9.44072 16.051 8.26276L16.0505 3.68124C16.0505 2.47696 15.0255 1.50847 13.8118 1.50847H12.2204C11.9237 0.644599 11.0876 0.0162354 10.0897 0.0162354H8.82201C7.82408 0.0162354 6.98799 0.644553 6.69129 1.50847H5.09997C3.85914 1.50847 2.86126 2.50328 2.86126 3.68124V6.97962C2.5744 7.0615 2.29868 7.1488 2.03491 7.24121C-0.231183 8.03506 -1.61621 9.20606 -1.61621 10.5659C-1.61621 10.8539 -1.56221 11.1419 -1.42731 11.4298C-0.510299 13.4717 3.69744 14.9376 9.09192 14.9376C13.3536 14.9376 16.8869 14.0213 18.6132 12.6339C19.3144 12.66 20.0158 12.7124 20.717 12.7124H20.771C20.825 12.7124 20.8519 12.6863 20.8788 12.6339C20.9326 12.608 20.9595 12.5555 20.9324 12.477ZM9.4691 2.55552C11.4111 2.55552 13.0024 4.09998 13.0024 5.98479C13.0024 7.8696 11.4111 9.41405 9.4691 9.41405C7.52709 9.41405 5.93576 7.8696 5.93576 5.98479C5.93576 4.10016 7.50016 2.55552 9.4691 2.55552Z" fill="#4B8D71"/>
<path d="M11.6784 6.10258C11.6784 7.29533 10.6864 8.26234 9.46264 8.26234C8.23911 8.26234 7.24707 7.29537 7.24707 6.10258C7.24707 4.90996 8.23911 3.94299 9.46264 3.94299C10.6863 3.94299 11.6784 4.90996 11.6784 6.10258Z" fill="#4B8D71"/>
</g>
</svg>
)

const showMoreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <path
      d="M1 6.00049L5.17391 9.47875L9 6.00049"
      stroke="#42ACCD"
      stroke-width="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1 1.00049L5.17391 4.47875L9 1.00049"
      stroke="#42ACCD"
      stroke-width="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const showLessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
  >
    <path
      d="M1 4.47803L5.17391 0.999767L9 4.47803"
      stroke="#42ACCD"
      stroke-width="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1 9.47803L5.17391 5.99977L9 9.47803"
      stroke="#42ACCD"
      stroke-width="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const unitMapIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M12.851 13.6559L15.5013 12.3862L11.8498 10.6147L7.19727 12.8587L10.8487 14.6007L12.851 13.6559Z"
      fill="#666666"
    />
    <path
      d="M19.8076 16.2617L21.8135 15.3187L16.1797 12.6079L14.1738 13.5803L19.8076 16.2617Z"
      fill="#666666"
    />
    <path
      d="M2 15.4311L6.57568 13.2637L13.078 16.3944L8.7431 18.5618L2 15.4311Z"
      fill="#666666"
    />
    <path
      d="M11.6328 14.9495L15.4028 12.9536L21.0846 15.576L17.1718 17.5985L11.6328 14.9495Z"
      fill="#666666"
    />
    <path
      d="M14.0185 16.8571L16.3477 17.9751L12.062 20.1179L9.73279 19.031L14.0185 16.8571Z"
      fill="#666666"
    />
    <path
      d="M11.4771 13.4266L14.1446 7.8673C14.6306 7.24747 14.9229 6.45659 14.9229 5.59519C14.9229 3.61268 13.3772 2 11.4771 2C9.57699 2 8.03125 3.61273 8.03125 5.59519C8.03125 6.4569 8.32374 7.24766 8.80964 7.8675L11.4771 13.4266ZM11.4771 4.43722C12.0899 4.43722 12.5867 4.95556 12.5867 5.59502C12.5867 6.23447 12.0899 6.75281 11.4771 6.75281C10.8643 6.75281 10.3675 6.23447 10.3675 5.59502C10.3675 4.95556 10.8644 4.43722 11.4771 4.43722Z"
      fill="#666666"
    />
  </svg>
);

const unitMapIconLight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.851 11.6554L13.5013 10.3857L9.84983 8.61426L5.19727 10.8582L8.8487 12.6002L10.851 11.6554Z"
      fill="#42ACCD"
    />
    <path
      d="M17.8076 14.2612L19.8135 13.3182L14.1797 10.6074L12.1738 11.5798L17.8076 14.2612Z"
      fill="#42ACCD"
    />
    <path
      d="M0 13.4301L4.57568 11.2627L11.078 14.3934L6.7431 16.5608L0 13.4301Z"
      fill="#42ACCD"
    />
    <path
      d="M9.63281 12.949L13.4028 10.9531L19.0846 13.5755L15.1718 15.598L9.63281 12.949Z"
      fill="#42ACCD"
    />
    <path
      d="M12.0185 14.8566L14.3477 15.9746L10.062 18.1175L7.73279 17.0305L12.0185 14.8566Z"
      fill="#42ACCD"
    />
    <path
      d="M9.47714 11.4266L12.1446 5.8673C12.6306 5.24747 12.9229 4.45659 12.9229 3.59519C12.9229 1.61268 11.3772 0 9.47708 0C7.57699 0 6.03125 1.61273 6.03125 3.59519C6.03125 4.4569 6.32374 5.24766 6.80964 5.8675L9.47714 11.4266ZM9.47714 2.43722C10.0899 2.43722 10.5867 2.95556 10.5867 3.59502C10.5867 4.23448 10.0899 4.75281 9.47714 4.75281C8.86427 4.75281 8.36755 4.23448 8.36755 3.59502C8.36755 2.95556 8.86435 2.43722 9.47714 2.43722Z"
      fill="#42ACCD"
    />
  </svg>
);

const unitMapIconGreen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
  <path d="M11.9633 11.8666L14.6612 10.574L10.9442 8.77075L6.20801 11.055L9.92506 12.8283L11.9633 11.8666Z" fill="#4B8D71"/>
  <path d="M19.0427 14.5175L21.0846 13.5576L15.3495 10.7981L13.3076 11.7879L19.0427 14.5175Z" fill="#4B8D71"/>
  <path d="M0.915039 13.6724L5.57295 11.4661L12.1921 14.6531L7.77932 16.8594L0.915039 13.6724Z" fill="#4B8D71"/>
  <path d="M10.7197 13.1833L14.5574 11.1516L20.3413 13.8211L16.3582 15.88L10.7197 13.1833Z" fill="#4B8D71"/>
  <path d="M13.1495 15.1248L15.5205 16.2629L11.1578 18.4443L8.78677 17.3378L13.1495 15.1248Z" fill="#4B8D71"/>
  <path d="M10.5615 11.6312L13.277 5.97201C13.7717 5.34104 14.0692 4.53594 14.0692 3.65906C14.0692 1.64092 12.4957 -0.000732422 10.5615 -0.000732422C8.62722 -0.000732422 7.05371 1.64098 7.05371 3.65906C7.05371 4.53626 7.35146 5.34124 7.84609 5.97221L10.5615 11.6312ZM10.5615 2.48029C11.1853 2.48029 11.6911 3.00794 11.6911 3.65889C11.6911 4.30984 11.1853 4.83749 10.5615 4.83749C9.93764 4.83749 9.43199 4.30984 9.43199 3.65889C9.43199 3.00794 9.93773 2.48029 10.5615 2.48029Z" fill="#4B8D71"/>
</svg>
 )

const unitMapColor = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <g clip-path="url(#clip0_2426_23966)">
      <path
        d="M12.5961 14.5303L15.6727 13.0564L11.434 11L6.0332 13.6048L10.2719 15.6269L12.5961 14.5303Z"
        fill="#42ACCD"
      />
      <path
        d="M20.6707 17.5548L22.9992 16.4602L16.4593 13.3135L14.1309 14.4422L20.6707 17.5548Z"
        fill="#42ACCD"
      />
      <path
        d="M0 16.5912L5.31155 14.0752L12.8595 17.7094L7.82754 20.2254L0 16.5912Z"
        fill="#42ACCD"
      />
      <path
        d="M11.1816 16.0321L15.5579 13.7153L22.1534 16.7594L17.6114 19.1073L11.1816 16.0321Z"
        fill="#42ACCD"
      />
      <path
        d="M13.9505 18.2461L16.6543 19.5439L11.6794 22.0314L8.97562 20.7696L13.9505 18.2461Z"
        fill="#42ACCD"
      />
      <path
        d="M11.0001 14.2642L14.0966 7.81089C14.6607 7.09137 15 6.17331 15 5.17337C15 2.87203 13.2057 1 11 1C8.79432 1 7 2.87209 7 5.17337C7 6.17366 7.33953 7.0916 7.90357 7.81112L11.0001 14.2642ZM11.0001 3.82918C11.7114 3.82918 12.2881 4.43088 12.2881 5.17317C12.2881 5.91547 11.7114 6.51717 11.0001 6.51717C10.2886 6.51717 9.71202 5.91547 9.71202 5.17317C9.71202 4.43088 10.2887 3.82918 11.0001 3.82918Z"
        fill="#0F0538"
      />
    </g>
    <defs>
      <clipPath id="clip0_2426_23966">
        <rect width="23" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const applyNowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <path
      d="M9.79077 1.5556C9.33052 1.5556 8.95734 1.2073 8.95734 0.777733C8.95734 0.348167 9.33052 0 9.79077 0H14.7907C15.0117 0 15.2236 0.0819 15.3799 0.227863C15.5361 0.373697 15.624 0.571497 15.624 0.77773V5.4444C15.624 5.87396 15.251 6.22226 14.7907 6.22226C14.3305 6.22226 13.9573 5.87396 13.9573 5.4444V2.65546L6.21342 9.88346C5.88795 10.1871 5.36032 10.1871 5.03486 9.88346C4.70938 9.57969 4.70938 9.08723 5.03486 8.78346L12.7791 1.5558L9.79077 1.5556ZM0.624023 3.11107C0.624023 2.25197 1.37027 1.5556 2.29073 1.5556H6.45714C6.91739 1.5556 7.29056 1.90377 7.29056 2.33333C7.29056 2.7629 6.91739 3.11107 6.45714 3.11107H2.29073V12.4444H12.2907V8.55573C12.2907 8.12617 12.6637 7.77787 13.124 7.77787C13.5842 7.77787 13.9572 8.12617 13.9572 8.55573V12.4444C13.9572 13.3035 13.2111 14 12.2907 14H2.29073C1.37027 14 0.624023 13.3035 0.624023 12.4444V3.11107Z"
      fill="#42ACCD"
    />
  </svg>
);

const applyNowIconGreen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M9.16674 1.5556C8.7065 1.5556 8.33332 1.2073 8.33332 0.777733C8.33332 0.348167 8.7065 0 9.16674 0H14.1667C14.3877 0 14.5996 0.0819 14.7559 0.227863C14.9121 0.373697 15 0.571497 15 0.77773V5.4444C15 5.87396 14.627 6.22226 14.1667 6.22226C13.7065 6.22226 13.3333 5.87396 13.3333 5.4444V2.65546L5.5894 9.88346C5.26393 10.1871 4.7363 10.1871 4.41083 9.88346C4.08536 9.57969 4.08536 9.08723 4.41083 8.78346L12.1551 1.5558L9.16674 1.5556ZM0 3.11107C0 2.25197 0.746247 1.5556 1.66671 1.5556H5.83312C6.29336 1.5556 6.66654 1.90377 6.66654 2.33333C6.66654 2.7629 6.29336 3.11107 5.83312 3.11107H1.66671V12.4444H11.6667V8.55573C11.6667 8.12617 12.0397 7.77787 12.4999 7.77787C12.9602 7.77787 13.3332 8.12617 13.3332 8.55573V12.4444C13.3332 13.3035 12.5871 14 11.6667 14H1.66671C0.746247 14 0 13.3035 0 12.4444V3.11107Z" fill="#4B8D71"/>
  </svg>
) 

const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
  >
    <path
      d="M1.01386 7H20.7031M20.7031 7L14.3336 1M20.7031 7L14.3336 13"
      stroke="white"
      stroke-width="1.33632"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const leftBackArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="19"
    viewBox="0 0 11 19"
    fill="none"
  >
    <path
      d="M9.7292 1L1.68532 8.62052C1.30986 8.97622 1.30182 9.57159 1.66753 9.9373L9.7292 17.999"
      stroke="#49536C"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
const leftBackArrowEmbedded = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <circle cx="14" cy="14" r="13.5" fill="#0F0538" stroke="black" />
    <path
      d="M21.0605 14.0909H7M7 14.0909L12.4045 9M7 14.0909L12.4045 19.1818"
      stroke="white"
      stroke-width="1.27273"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const applyNow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"K
    fill="none"
  >
    <path
      d="M10.1121 1.5556C9.65181 1.5556 9.27863 1.2073 9.27863 0.777733C9.27863 0.348167 9.65181 0 10.1121 0H15.112C15.333 0 15.5449 0.0819 15.7012 0.227863C15.8574 0.373697 15.9453 0.571497 15.9453 0.77773V5.4444C15.9453 5.87396 15.5723 6.22226 15.112 6.22226C14.6518 6.22226 14.2786 5.87396 14.2786 5.4444V2.65546L6.53471 9.88346C6.20924 10.1871 5.68161 10.1871 5.35615 9.88346C5.03067 9.57969 5.03067 9.08723 5.35615 8.78346L13.1004 1.5558L10.1121 1.5556ZM0.945312 3.11107C0.945312 2.25197 1.69156 1.5556 2.61202 1.5556H6.77843C7.23868 1.5556 7.61185 1.90377 7.61185 2.33333C7.61185 2.7629 7.23868 3.11107 6.77843 3.11107H2.61202V12.4444H12.612V8.55573C12.612 8.12617 12.985 7.77787 13.4453 7.77787C13.9055 7.77787 14.2785 8.12617 14.2785 8.55573V12.4444C14.2785 13.3035 13.5324 14 12.612 14H2.61202C1.69156 14 0.945312 13.3035 0.945312 12.4444V3.11107Z"
      fill="#42ACCD"
    />
  </svg>
);

export {
  Select,
  SelectContainer,
  DetailsContainer,
  Name,
  Price,
  Disclaimer,
  Description,
  ApartmentInfo,
  ApartmentInfoEmptyPrice,
  DescImg,
  PriceDescription,
  NameAndPrice,
  DisclaimerAndInfoWrapper,
  BedroomDescription,
  ActionButtonsWrapper,
  unitIcon,
  virtualIcon,
  unitMapIcon,
  showMoreIcon,
  showLessIcon,
  applyNowIcon,
  unitMapColor,
  unitMapIconLight,
  unitMapIconGreen,
  unitIconLight,
  unitIconGreen,
  virtualIconLight,
  virtualIconGreen,
  rightArrow,
  leftBackArrow,
  leftBackArrowEmbedded,
  applyNow,
  applyNowIconGreen
};
